import React, { useState, useEffect } from 'react';
import DataTable from 'datatables.net-react'
import DT from 'datatables.net'
import isEqual from 'lodash/isEqual'

DataTable.use(DT)

const GncDataTable = ({dataUrl, data, tableHead, tableFoot, tableSlots, columns, localStorageOrderKey, tableRef, defaultOrder}) => {
    const [tableData, setTableData] = useState([])
    const [isReady, setIsReady] = useState(false)
    
    const getInitialOrder = () => {
        const savedOrder = localStorage.getItem(localStorageOrderKey)
        try {
            return savedOrder ? JSON.parse(savedOrder) : defaultOrder
        } catch {
            return defaultOrder
        }
    }
    const initialOrder = getInitialOrder()
    
    const options = {
        paging: true,
        pageLength: 100,
        lengthMenu: [ 100, 1000, 2000 ],
        autoWidth: false,
        order: initialOrder,
    }

    const columnsWithOrderSequence = columns.map(item => {
        item.orderSequence = ['asc', 'desc']
        return item
    })
    
    useEffect(() => {
        if( typeof(data) !== 'undefined' ) {
            if( ! isEqual(data, tableData) ) {
                setTableData(data)
            }
            return
        }
        
//        fetch(dataUrl + '&page_size=10&page=1', { credentials: 'same-origin' })
        fetch(dataUrl, { credentials: 'same-origin' })
            .then(function(response) {
                return response.json()
            })
            .then(function(json) {
                setTableData(json.results)
            })
    }, [data, dataUrl])

    // Hide table until it's drawn - use requestAnimationFrame to ensure
    // the browser has actually painted the table before showing it
    const handleDraw = () => {
        if (!isReady) {
            requestAnimationFrame(() => {
                setIsReady(true)
            })
        }
    }
    
    const className = "table table-striped table-bordered table-hover " + ( isReady ? "" : "hidden" )
    return (
        <DataTable
            className={className}
            options={options}
            columns={columnsWithOrderSequence}
            ref={tableRef}
            data={tableData}
            slots={tableSlots}
            onDraw={handleDraw}
            onOrder={(e, settings, order) => {
                if( ! order.length ) {
                    return
                }
                const value = [[ order[0].col, order[0].dir ]]
                localStorage.setItem(localStorageOrderKey, JSON.stringify(value))
            }}
        >
            <thead>
                {tableHead}
            </thead>
            <tfoot>
                {tableFoot}
            </tfoot>
        </DataTable>
    )
}

export default GncDataTable
